<template><!--隐私协议SDK-->
  <div class="privacySDK">

    <div>
      SDK技术由与我们合作的第三方机构提供，我们仅能知悉其要求获得授权的权限。第三方机构将会需要收集您的信息，我们无法获取您的信息，除非第三方机构明确向我们披露的要收集的敏感信息。第三方机构要求获得的权限以及明确向我们披露的收集的敏感信息。
      <br> 第三方机构拒绝提供信息仅会使您无法使用第三方机构提供的技术所搭载的功能，但不影响您使用陌撩漂流瓶的其他功能。

      <table border="1"
             style="border:1px solid rgba(0,0,0,.1);min-height:25px;line-height:25px;text-align:left;border-collapse:collapse;table-layout:fixed;width:100%;word-break:break-all;word-wrap:break-word;color:rgba(0,0,0,.9);margin: 20px 0;">
        <tr>
          <th style="padding:5px 2px;text-align:center;width:10%">第三方公司名称</th>
          <th style="padding:5px 2px;text-align:center;width:8%">产品/服务</th>
          <th style="padding:5px 2px;text-align:center;width:20%">共享信息名称</th>
          <th style="padding:5px 2px;text-align:center;width:8%">使用目的</th>
          <th style="padding:5px 2px;text-align:center;width:8%">使用场景</th>
          <th style="padding:5px 2px;text-align:center;width:8%">共享方式</th>
          <th style="padding:5px 2px;text-align:center;width:20%">第三方隐私协议</th>
        </tr>

        <tr>
          <td> 华为软件技术有限公司</td>
          <td> 华为推送SDK</td>
          <td> 应用基本信息（应用版本号/应用包名)、应用内设备标识符(AAID/Push
            Token)、设备的硬件信息、系统基本信息和系统设置信息、已安装应用包名信息、设备型号
          </td>
          <td> 为App用户提供消息推送技术服务</td>
          <td> 每次启动时注册推送通道</td>
          <td> SDK本机采集 后台接口传输</td>
          <td> https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177</td>
        </tr>
        <tr>
          <td> 北京小米移动软件有限公司</td>
          <td> 小米推送SDK</td>
          <td> 设备信息（IMEI/OAID（适用于Android Q以上系统）、IMEI MD5/MEIDMD5、Android
            ID、VAID、AAID，以及您的MID（适用于MIUI系统）、设备型号）、后台运行时获取设备信息、使用推送服务的应用信息（如APP包名及版本号，运行状态）、推送SDK版本号、网络相关信息（如IP或域名连接结果，当前网络类型）、消息发送结果，通知栏状态（如通知栏权限、用户点击行为），锁屏状态（如是否锁屏，是否允许锁屏通知）、SSID；终端权限（读取手机状态和身份）
          </td>
          <td> 为App用户提供消息推送技术服务</td>
          <td> 每次启动时注册推送通道</td>
          <td> SDK本机采集 后台接口传输</td>
          <td> https://dev.mi.com/console/doc/detail?pId=1822</td>
        </tr>
        <tr>
          <td> 广东欢太科技有限公司</td>
          <td> OPPO 推送 SDK</td>
          <td> 设备信息（如IMEI号，Serial Number，IMSI，User ID，Android ID，Google Advertising ID,
            手机Region设置，设备型号，手机电量，手机操作系统版本及语言）、后台运行时获取设备信息、OAID、AAID、VAID；终端权限（读取手机状态和身份）
          </td>
          <td> 为App用户提供消息推送技术服务</td>
          <td> 每次启动时注册推送通道</td>
          <td> SDK本机采集 后台接口传输</td>
          <td> https://open.oppomobile.com/new/developmentDoc/info?id=11228</td>
        </tr>
        <tr>
          <td> 维沃移动通信有限公司</td>
          <td> VIVO推送SDK</td>
          <td> 设备信息（操作系统版本号、应用程序信息、设备标识符（如IMEI号、SIM 和 IMSI、移动国家码和vivo
            Android设备的移动网号等）、MAC地址、移动运营商、使用语言、系统设置等系统、设备和应用程序数据）、后台运行时获取设备信息；终端权限（读取手机状态和身份）
          </td>
          <td> 为App用户提供消息推送技术服务</td>
          <td> 每次启动时注册推送通道</td>
          <td> SDK本机采集 后台接口传输</td>
          <td> https://dev.vivo.com.cn/documentCenter/doc/366</td>
        </tr>
        <tr>
          <td> 珠海市魅族通讯设备有限公司</td>
          <td> 魅族推送SDK</td>
          <td> 设备参数及系统信息(设备类型、设备型号、系统版本、及相关硬件信息)、设备标识符（IMEI、IDFA、Android ID、GID、
            MAC、OAID、VAID、AAID、IMSI、MEID、UAID、SN、ICCID、SIM信息）、网络信息(IP
            地址、WiFi状态、基站信息、DNS地址、DHCP地址、SSID、BSSID)与粗略位置信息、应用列表信息、运营商信息；终端权限（存储权限、读取手机状态和身份）
          </td>
          <td> 为App用户提供消息推送技术服务</td>
          <td> 每次启动时注册推送通道</td>
          <td> SDK本机采集 后台接口传输</td>
          <td> http://static.meizu.com/resources/term/privacy8.html</td>
        </tr>
        <tr>
          <td> 中移互联网有限公司(中国移动)</td>
          <td> 移动 SDK</td>
          <td>
            设备信息（手机设备类型、手机操作系统、硬件厂商、国际移动设备识别码、运营商类型、网络类型、sim卡数量、国际移动用户识别码、网络地址、屏幕尺寸、屏幕分辨率、IMSI、SIM卡信息、IMEI、IP地址、ICCID、Android
            ID、WiFi状态）、网络地址、SIM卡状态信息、本机号码、MAC地址、设备型号、SIM国家代码、SSID、BSSID、指定包名信息；终端权限（读取手机状态和身份）
          </td>
          <td> 移动用户一键登录</td>
          <td> 在用户每次登录时使用</td>
          <td> SDK本机采集 后台接口传输</td>
          <td> https://wap.cmpassport.com/resources/html/contract.html</td>
        </tr>
        <tr>
          <td> 世纪龙信息网络有限责任公司(天翼数字生活)</td>
          <td> 电信 SDK</td>
          <td> 设备标识（IMSI、SIM卡信息、Android
            ID、ICCID、WiFi状态）、任务列表、MAC地址、本机号码、运营商信息、设备型号；终端权限（读取手机状态和身份）
          </td>
          <td> 电信用户一键登录</td>
          <td> 在用户每次登录时使用</td>
          <td> SDK本机采集 后台接口传输</td>
          <td> https://e.189.cn/sdk/agreement/show.do?order=2&type=main&appKey=&hidetop=true&returnUrl=</td>
        </tr>
        <tr>
          <td> 小沃科技有限公司 (中国联通)</td>
          <td> 联通 SDK</td>
          <td> 设备信息（网络类型、网络地址、运营商类型、本机手机号、国际移动用户标识码、sim卡数量、手机设备类型、手机操作系统、硬件厂商、屏幕尺寸、屏幕分辨率信息、IMSI、SIM卡信息、ICCID、Android
            ID、WiFi状态）、MAC地址、本机号码、运营商信息
          </td>
          <td> 联通用户一键登录</td>
          <td> 在用户每次登录时使用</td>
          <td> SDK本机采集 后台接口传输</td>
          <td> https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true</td>
        </tr>
        <tr>
          <td> 深圳市腾讯计算机系统有限公司</td>
          <td> 微信 SDK</td>
          <td> 设备信息（IMEI/MAC/Android ID/SIM卡IMSI/IP）、应用列表、微信包名；终端权限（存储权限、读取手机状态和身份）</td>
          <td> 第三方登录、分享、支付</td>
          <td> 在用户每次登陆和分享时使用
            在用户每次支付时使用
          </td>
          <td> SDK本机采集 后台接口传输</td>
          <td> https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</td>
        </tr>
        <tr>
          <td> 支付宝（中国）网络技术有限公司</td>
          <td> 支付宝 SDK</td>
          <td> 设备标识（IMEI、IMSI、硬件序列号、Android
            ID、ICCID、SIM卡序列号、OAID）、MAC地址、设备屏幕密度、网络信息（网络类型、WiFi状态、运营商信息、BSSID、SSID）、应用数据、应用包名、宿主App进程信息、传感器列表、IP地址、设备型号；终端权限（存储权限、读取手机状态和身份）
          </td>
          <td> 支付宝支付或提现</td>
          <td> 在用户每次支付时使用</td>
          <td> SDK本机采集 后台接口传输</td>
          <td>
            https://opendocs.alipay.com/open/54/01g6qm#%E6%94%AF%E4%BB%98%E5%AE%9D%20App%20%E6%94%AF%E4%BB%98%E5%AE%A2%E6%88%B7%E7%AB%AF%20SDK%20%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96
          </td>
        </tr>
        <tr>
          <td> 移动安全联盟</td>
          <td> Oaid SDK</td>
          <td> 设备信息（IMEI/MAC/Android
            ID/SIM卡IMSI/IP/OAID/VAID/AAID/已安装应用包名信息/设备型号）、运营商信息、后台运行时获取设备信息；终端权限（存储权限、读取手机状态和身份）
          </td>
          <td> 移动联盟广告标识符</td>
          <td> 在每次启动时获取标识符</td>
          <td> SDK本机采集</td>
          <td> http://www.msa-alliance.cn/</td>
        </tr>
        <tr>
          <td>友盟同欣（北京）科技有限公司</td>
          <td> 友盟移动统计SDK</td>
          <td> 设备信息（Android ID/IDFA/IDFV/OAID/OpenUDID/GUID ; 可选-IMEI/IMSI/ICCID）、 网络信息、位置信息、应用列表
          </td>
          <td> 在每次启动时、程序崩溃时获取设备信息</td>
          <td> 进行APP数据统计分析</td>
          <td> SDK本机采集</td>
          <td>https://www.umeng.com/page/policy </td>
        </tr>


        <tr>
          <td> 深圳市腾讯计算机系统有限公司</td>
          <td> 腾讯 Bugly SDK</td>
          <td> 设备信息（IMEI/MAC/Android
            ID/SIM卡IMSI/IP）、后台运行时获取设备信息、设备型号、指定包名信息；终端权限（存储权限、读取手机状态和身份）
          </td>
          <td> 统计分析</td>
          <td> 在每次启动时、程序崩溃时获取设备信息</td>
          <td> SDK本机采集 后台接口传输</td>
          <td> https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</td>
        </tr>
        <tr>
          <td> 高德软件有限公司</td>
          <td> 高德定位SDK</td>
          <td> 设备标识信息（IMEI、IDFA、IDFV、Android
            ID、MEID、MAC地址、OAID、IMSI、ICCID、硬件序列号）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（系统属性、设备型号、操作系统、运营商信息）、设备信息（如IP
            地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、信号强度的信息、蓝牙信息、SIM卡状态信息、IP地址、传感器信息（矢量、加速度、压力）、设备信号强度信息、外部存储目录）、位置信息（经纬度、精确位置、粗略位置）；终端权限（存储权限、位置权限、读取手机状态和身份）
          </td>
          <td> 定位</td>
          <td> 在使用配对、动态时进行定位</td>
          <td> SDK本机采集</td>
          <td> https://lbs.amap.com/pages/privacy/</td>
        </tr>
        <tr>
          <td> 阿里云计算有限公司</td>
          <td> 阿里云号码认证</td>
          <td>
            收集信息范围：设备信息（包括相机权限用于提供人脸识别服务，并采集常用设备信息（IMEI/IMSI、SIM卡序列号/MAC地址）、网络信息用于服务过程中的安全风险。
          </td>
          <td> 手机号一键登录功能</td>
          <td> 用户账号注册登录</td>
          <td> SDK本机采集 后台接口传输</td>
          <td>
            https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html
          </td>
        </tr>
        <tr>
          <td> 阿里云计算有限公司</td>
          <td> 阿里云OSS</td>
          <td> 共享信息名称，收集信息范围：外部存储设备、网络信息（含Wi-Fi信息）中国移动、中国联通、中国电信、IP地址、获取IP</td>
          <td> 图片存储</td>
          <td> 用于文件上传</td>
          <td> 后台接口传输</td>
          <td>
            https://terms.alicdn.com/legal-agreement/terms/privacy_policy_full/20240202100310511/20240202100310511.html
          </td>
        </tr>
        <tr>
          <td> 深圳市腾讯计算机系统有限公司</td>
          <td> 即时通讯IM</td>
          <td> IP地址，MAC地址，设备信息，获取设备传感器（IMEI/MAC/Android ID/SIM卡IMSI）、后台运行时获取设备信息</td>
          <td> 即时通信</td>
          <td> 嵌入该SDK,SDK将传输个人信息</td>
          <td> SDK本机采集 后台接口传输</td>
          <td> https://privacy.qq.com/policy/tencent-privacypolicy</td>
        </tr>

      </table>

    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
  created() {
  }
}
</script>

<style>

.privacySDK {
  width: 92%;
  margin: auto;
  font-size: 14px;
  line-height: 26px;
}

.privacySDK div {
  margin-bottom: 8px;
}

.privacySDK h3 {
  margin: 8px 0;
}

.privacySDK h4 {
  margin: 2px 0;
}

p {
  margin: 4px 0;
}

</style>
